// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1_Ts_","cls2":"FeedbackModal-cls2_jPa FeedbackModal-cls1_Ts_"};